import { render, staticRenderFns } from "./MduiCheckbox.vue?vue&type=template&id=24a3f6ea&scoped=true"
import script from "./MduiCheckbox.vue?vue&type=script&lang=js"
export * from "./MduiCheckbox.vue?vue&type=script&lang=js"
import style0 from "./MduiCheckbox.vue?vue&type=style&index=0&id=24a3f6ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a3f6ea",
  null
  
)

export default component.exports